import * as ReactQuery from 'react-query';
import React from 'react';

const queryClient = new ReactQuery.QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity, // Change to milliseconds in case you want to refetch data in the background
      cacheTime: Infinity, // Change to milliseconds in case you want to garbage collect unused data
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const QueryClientProvider =
  ReactQuery.QueryClientProvider as unknown as React.FC<{
    client: ReactQuery.QueryClient;
    children?: React.ReactNode;
  }>;

export const ServiceProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
